import {
    FETCH_TECHNICIAN_PERMISSION,
    RESET_TECHNICIAN_PERMISSION,
  } from "../../constants/action.constants";
  
  const initialState = {
    data: {},
  };
  
  const technicianPermissionListReducer = (state = initialState, action) => {
    switch (action.type) {
      case FETCH_TECHNICIAN_PERMISSION:
        return { data: action.payload };
      case RESET_TECHNICIAN_PERMISSION:
        return initialState;
      default:
        return state;
    }
  };
  
  export default technicianPermissionListReducer;
  